import type { Router } from "vue-router";
import { getRouter } from "@shared/router/router-instance";
import { APP_TARGET } from "@shared/utils/storage";

/** 管理端 / 客户端优先落地：产品管理 */
export const APP_PRODUCT_HOME_PATH = "/product/goods";
/** 无产品管理权限时的默认页：个人中心（mapUserMenus 始终注入） */
export const APP_FALLBACK_HOME_PATH = "/system/personalCenter";

/** 是否为已注册业务路由（排除 catch-all → /404） */
export function isRegisteredAppPath(path: string, router: Router | null = getRouter()): boolean {
    if (!router) return false;
    const resolved = router.resolve(path);
    return resolved.matched.some(r => {
        const name = r.name;
        return name != null && name !== "FallbackNotFound" && name !== "NotFound";
    });
}

/**
 * 各端「首页」落地 path：logo / 页签首页图标 / 404 返回 / 登录后 dashboard 等统一走这里。
 * 客户端：工作台 /dashboard。
 * 管理端：有产品管理权限 → 产品库；否则 → 个人中心。
 * 管理后台仍进工作台。
 */
export function getAppHomePath(router: Router | null = getRouter()): string {
    if (APP_TARGET === "customer") {
        return "/dashboard";
    }
    if (APP_TARGET === "manage") {
        if (isRegisteredAppPath(APP_PRODUCT_HOME_PATH, router)) {
            return APP_PRODUCT_HOME_PATH;
        }
        return APP_FALLBACK_HOME_PATH;
    }
    return "/dashboard";
}
